export const FIRESTORE_COLLECTION_PATH = {
  USERS: "users",
  PROJECTS: "projects",
  SOCIAL_LINKS: "socialLinks",
  RESUMES: "resumes",
  BIOS: "bios",
  DOCUMENTS: "documents",
  MEDIA_METADATA: "media_metadata",
  DESCRIPTORS: "descriptors",
  USAGE: "usage",
};

export enum PUBLIC_ROUTE_IDS {
  GET_SOCIAL_LINKS = "getSocialLinks",
  GET_BIO = "getBio",
  GET_RESUME = "getResume",
  GET_BLOG = "getBlog",
  GET_BLOG_LIST = "getBlogList",
  GET_CATEGORIES = "getCategories",
  GET_TAGS = "getTags",
  GET_BREADCRUMB = "getBreadcrumb",
}

export const FIRESTORE_DOCUMENT_PATH = {};
